export const tmCardPurple = "#722ED1";
export const tmCardPurpleHover = "#4a18a3";